import { render, staticRenderFns } from "./ProductSideSheetFooter.vue?vue&type=template&id=4f7e235b&scoped=true"
import script from "./ProductSideSheetFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductSideSheetFooter.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProductSideSheetFooter.vue?vue&type=style&index=0&id=4f7e235b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7e235b",
  null
  
)

export default component.exports